import OrdersDataActions from './OrdersData/OrdersDataActions';
import OrdersHistoryActions from './OrdersHistory/OrdersHistoryActions';

export default {
	data: OrdersDataActions,
	history: OrdersHistoryActions,
};
